export default __webpack_public_path__ + "static/media/Kibawe3.f49f1601.png";